import { Check, Copy, ArrowRight } from 'lucide-react';
import { cn } from '@/lib/utils';

/** Overlay de hover premium para smilies / peões / powers necessários. */
export function GalleryHoverOverlay({
  mode = 'copy',
  isCopied = false,
}: {
  mode?: 'copy' | 'view';
  isCopied?: boolean;
}) {
  const label =
    mode === 'view' ? 'Ver power' : isCopied ? 'Copiado!' : 'Copiar código';

  return (
    <div
      className={cn(
        'pointer-events-none absolute inset-0 z-10 flex flex-col items-center justify-center gap-1.5 rounded-xl',
        'opacity-0 transition-all duration-200 ease-out',
        'group-hover:opacity-100',
        isCopied && 'opacity-100'
      )}
      aria-hidden
    >
      {/* Glow + vidro navy */}
      <div
        className={cn(
          'absolute inset-0 rounded-xl',
          'bg-gradient-to-b from-[#000b6a]/75 via-[#030023]/88 to-[#000b6a]/92',
          'backdrop-blur-[2px]',
          'ring-1 ring-inset ring-sky-300/25',
          'shadow-[inset_0_1px_0_rgba(255,255,255,0.12)]'
        )}
      />
      <div
        className={cn(
          'absolute inset-x-3 top-2 h-px',
          'bg-gradient-to-r from-transparent via-sky-300/50 to-transparent'
        )}
      />

      <span
        className={cn(
          'relative flex h-8 w-8 items-center justify-center rounded-full',
          'bg-white/15 ring-1 ring-white/30',
          'transition-transform duration-200 ease-out',
          'group-hover:scale-110',
          isCopied && 'bg-emerald-400/25 ring-emerald-300/40'
        )}
      >
        {mode === 'view' ? (
          <ArrowRight className="h-3.5 w-3.5 text-white" />
        ) : isCopied ? (
          <Check className="h-3.5 w-3.5 text-emerald-200" />
        ) : (
          <Copy className="h-3.5 w-3.5 text-white" />
        )}
      </span>
      <span className="relative font-poppins text-[10px] font-bold tracking-wide text-white drop-shadow-sm">
        {label}
      </span>
    </div>
  );
}

/** Classes partilhadas do cartão de galeria (hover lift + glow). */
export function galleryItemHoverClass(viewMode: 'light' | 'dark') {
  return cn(
    'transition-[transform,box-shadow] duration-200 ease-out',
    'hover:-translate-y-0.5',
    'motion-reduce:hover:translate-y-0',
    viewMode === 'dark'
      ? 'hover:shadow-[0_12px_28px_-10px_rgba(0,11,106,0.65)]'
      : 'hover:shadow-[0_10px_24px_-10px_rgba(0,11,106,0.28)]'
  );
}

/** Escala suave do smilie/peão no hover do cartão. */
export const galleryMediaHoverClass =
  'transition-transform duration-200 ease-out group-hover:scale-110 motion-reduce:group-hover:scale-100';
